import React from 'react';
import StyledDivider from '../../styles/elements/Divider';
const Divider = ({ customStyle }) => <StyledDivider customStyle={customStyle}/>;
Divider.defaultProps = {
    customStyle: {},
};
export default Divider;
